import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Card, Grid, Form} from 'semantic-ui-react';
import ImageUpload from '../../../common/components/imageUpload';
import {Actions} from '../../../common/actions';

class ProductInfo extends Component {
  constructor(props) {
    super(props);
    this.state = {'preview': ''};
    this.handleChange = this.handleChange.bind(this);
    this.handleImageLoad = this.handleImageLoad.bind(this);
    this.handleClear = this.handleClear.bind(this);
  }

  componentDidUpdate(prevProps) {
    const imageLoaded = prevProps.loadingImage && !this.props.loadingImage;
    const partChanged = prevProps.image !== this.props.image && !this.props.image;

    if (partChanged || imageLoaded) {
      this.setState({'preview': ''});
    }
  }

  handleChange(event, data) {
    const {name, value} = data;
    this.props.changePartsFormValue(name, value);
  }

  handleImageLoad(event) {
    const {partCode} = this.props;
    const {files} = event.target;

    if (partCode && files.length) {
      const formData = new FormData();
      formData.append('image', files[0]);
      this.props.savePartImage(partCode, formData);
      this.setState({'preview': URL.createObjectURL(files[0])});
      return;
    }

    this.props.addMessageBoxWarning('Por favor especifique el código del repuesto');
  }

  handleClear(event) {
    this.props.changePartsFormValue('image', '');
    this.setState({'preview': ''});
  }

  parseOrigins() {
    const {origins} = this.props;
    return origins.map((origin) => ({'text': origin.origin, 'value': origin.code}));
  }

  showThumbnail() {
    const {preview} = this.state;
    const {image, loadingImage} = this.props;
    const date = new Date();

    if (loadingImage) {
      return preview;
    }

    return image ? `${process.env.REP_ASSETS_URL}/${image}?date=${date.getTime()}` : preview;
  }

  render() {
    const {loadingImage, productDescription, madeIn, loadingOrigins} = this.props;

    return (
      <Card raised fluid className='compatibility'>
        <Grid>
          <Grid.Row>
            <Grid.Column width='8'>
              <Form.TextArea
                label='Descripción del Producto'
                name='productDescription'
                value={productDescription}
                onChange={this.handleChange}
              />
              <Form.Select
                fluid
                search
                upward
                label='Fabricado en'
                name='madeIn'
                value={madeIn}
                onChange={this.handleChange}
                options={this.parseOrigins()}
                loading={loadingOrigins}
                disabled={loadingOrigins}
                noResultsMessage='No se encontraron resultados'
              />
            </Grid.Column>
            <Grid.Column width='8' textAlign='center'>
              <ImageUpload
                name='image'
                disabled={loadingImage}
                loading={loadingImage}
                preview={this.showThumbnail()}
                onChange={this.handleImageLoad}
                onClear={this.handleClear}
              />
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </Card>
    );
  }
}

const mapStateToProps = (state) => {
  const {values, loadingImage} = state.partsMaster || {};
  const {partCode, productDescription, madeIn, image} = values || {};

  return {
    'loadingOrigins': state.origin.loading,
    'origins': state.origin.list,
    loadingImage,
    partCode,
    productDescription,
    madeIn,
    image,
  };
};

const {changePartsFormValue, savePartImage, addMessageBoxWarning} = Actions;

export default connect(mapStateToProps, {changePartsFormValue, savePartImage, addMessageBoxWarning})(ProductInfo);
